import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import styles from './AvailabilityConflict.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, IRootState } from '../../../../redux/rootReducer';
import { addAvailability } from '../../../../redux/availability/actions/availability.action';
import Loader from '../../../common/loader/Loader';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { AvailabilityRedirectionContext } from '../../../context/availabilityRedirection';
import { addAvailabilityObj } from '../AvailabilityConfirm/AvailabilityConfirm';
import { assignLocker } from '../../../../redux/bms-locker/actions/bms-locker.action';
import toast from 'react-hot-toast';
import { error } from 'console';

export interface conflictedAvailabilityData {
    availabilityId: string;
    startDate: string;
    endDate: string;
    unitId: string;
    unitName: string;
    locationName: string;
    appointments?: null;
    locker: number;
    openTime: string;
    closeTime: string;
    unitYardiId?: string | null;
}

interface AddAvailabilityObjprops {
    locationId: string;
    unitId: string;
    locker: number;
    startDate: string;
    endDate: string;
    openingTime: string;
    closingTime: string;
    locationName: string;
    unitName: string;
}
interface AvailabilityConflictProps {
    location: string;
    setShowConflictDelete: Dispatch<SetStateAction<boolean>>;
    setShowConfirm: Dispatch<SetStateAction<boolean>>;
    setShowForm: Dispatch<SetStateAction<boolean>>;
    setShowConflicts: Dispatch<SetStateAction<boolean>>;
    setShowCalendar: Dispatch<SetStateAction<boolean>>;
    setOpen: Dispatch<SetStateAction<boolean>>;
    addAvailabilityObj: AddAvailabilityObjprops;
    setAddAvailabilityObj: Dispatch<SetStateAction<addAvailabilityObj>>;
}

const AvailabilityConflict = ({
    setShowForm,
    setShowConfirm,
    setShowConflicts,
    setShowCalendar,
    setShowConflictDelete,
    addAvailabilityObj,
    setAddAvailabilityObj,
    setOpen,
}: AvailabilityConflictProps) => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
    const lockerType = availabilityRedirectionContext?.locationDetails?.lockerName;
    const provisionId = availabilityRedirectionContext?.locationDetails?.provisioningId;

    const conflictedAvailabilityData = useSelector((state: IRootState) => state.availability.conflictedAvailability.data);
    const conflictedAvailabilityLoading = useSelector((state: IRootState) => state.availability.conflictedAvailability.loading);
    const getAvailabiliesLoader = useSelector((state: IRootState) => state.availability.availabilies.loading);

    const createAvailabilityForBMS = async (): Promise<{ success: boolean; locker: number | null }> => {
        setIsLoading(true);
        const assign = assignLocker(Number(provisionId), availabilityRedirectionContext?.availabilityData?.unitId || '');
        const { message, error, locker } = await assign();
        if (!error) {
            return { success: true, locker: locker };
        } else {
            toast.error(message);
            setIsLoading(false);
            setOpen(false);
            return { success: false, locker: null };
        }
    };

    const handleAddAvailability = async () => {
        let openTime = addAvailabilityObj.openingTime;
        let closeTime =
            (addAvailabilityObj.closingTime === '23:00' || addAvailabilityObj.closingTime === '00:00')
                ? '23:59'
                : moment(addAvailabilityObj.closingTime, 'HH:mm').add(1, 'hours').format('HH:mm');

        if (
            (addAvailabilityObj?.openingTime?.includes('AM') || addAvailabilityObj?.openingTime?.includes('PM')) &&
            (addAvailabilityObj.closingTime.includes('AM') || addAvailabilityObj.closingTime.includes('PM'))
        ) {
            openTime = moment(addAvailabilityObj.openingTime, 'h:mm A').format('HH:mm');
            closeTime =
                (moment(addAvailabilityObj.closingTime, 'h:mm A').format('HH:mm') === '23:00' || moment(addAvailabilityObj.closingTime, 'h:mm A').format('HH:mm') === '00:00') ? '23:59' : moment(addAvailabilityObj.closingTime, 'h:mm A').add(1, 'hours').format('HH:mm');
        }

        const { openingTime, closingTime, locationName, unitName, endDate, ...restObj } = addAvailabilityObj;

        const obj = {
            ...restObj,
            timeSlots: [
                {
                    openingTime: openTime,
                    closingTime: closeTime,
                },
            ],
            isVisitorTab: true,
            customAvailability: [
                {
                    day: 'Saturday',
                    timeSlots: [
                        {
                            openingTime: moment(openTime, 'hh:mm A').format('HH:mm'),
                            closingTime: moment(closeTime, 'hh:mm A').format('HH:mm'),
                        },
                    ],
                    isClosed: false,
                },
                {
                    day: 'Sunday',
                    timeSlots: [
                        {
                            openingTime: moment(openingTime, 'hh:mm A').format('HH:mm'),
                            closingTime: moment(closingTime, 'hh:mm A').format('HH:mm'),
                        },
                    ],
                    isClosed: false,
                },
            ],
        };
        try {
            if (availabilityRedirectionContext?.availabilityData.unitId && lockerType?.toLowerCase() === 'bms') {
                const { success: lockerAssigned, locker } = await createAvailabilityForBMS();

                const availabilityObj = {
                    ...obj,
                    locker: locker,
                };

                if (lockerAssigned) {
                    if (
                        availabilityRedirectionContext?.availabilityData.locationId &&
                        availabilityRedirectionContext?.availabilityData.unitId &&
                        availabilityRedirectionContext.availabilityData.lockerNumber
                    ) {
                        dispatch(
                            addAvailability(
                                availabilityObj,
                                addAvailabilityObj.locationId,
                                navigate,
                                availabilityRedirectionContext?.setStep,
                                undefined,
                                true,
                            ),
                        );
                    } else {
                        dispatch(addAvailability(availabilityObj, addAvailabilityObj.locationId));
                    }
                    setOpen(false);
                }
            } else {
                if (
                    availabilityRedirectionContext?.availabilityData.locationId &&
                    availabilityRedirectionContext?.availabilityData.unitId &&
                    availabilityRedirectionContext.availabilityData.lockerNumber
                ) {
                    dispatch(
                        addAvailability(
                            obj,
                            addAvailabilityObj.locationId,
                            navigate,
                            availabilityRedirectionContext?.setStep,
                            undefined,
                            true,
                        ),
                    );
                } else {
                    dispatch(addAvailability(obj, addAvailabilityObj.locationId));
                }
            }
            setOpen(false);
        } catch (error) {
            console.error(error);
        } finally {
            setOpen(false);
        }
    };

    const handleChangeAvailability = () => {
        setShowForm(false);
        setShowConfirm(false);
        setShowConflicts(false);
        setShowCalendar(true);
    };

    return (
        <>
            {(getAvailabiliesLoader || isLoading) && <Loader />}
            {!conflictedAvailabilityLoading && (
                <div className={styles.container}>
                    {/* <div className={styles.header}>
                        <h2 className={styles.title}>Existing Availability</h2>
                    </div> */}
                    <div className={styles.body}>
                        <div>
                            {/* <div className={styles.tableWrapper}>
                                {(conflictedAvailabilityData?.length && lockerType?.toLowerCase() === 'kiosk') > 0 ? (
                                    <table className={styles.conflictData}>
                                        <tr className={styles.tableHead}>
                                            <th>Property</th>
                                            <th>Unit Name</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Locker Number</th>
                                            <th>Opening Hours</th>
                                            <th>Closing Hours</th>
                                        </tr>
                                        {conflictedAvailabilityData.map((conflictedData: conflictedAvailabilityData) => (
                                            <tr
                                                onClick={() => {
                                                    setShowConflictDelete(true);
                                                    setShowConfirm(false);
                                                }}
                                                key={conflictedData.availabilityId}>
                                                <td>{conflictedData.locationName}</td>
                                                <td>{conflictedData.unitYardiId ? conflictedData.unitYardiId : conflictedData.unitName}</td>
                                                <td>{moment(conflictedData.startDate).format('MM-DD-YYYY')}</td>
                                                <td>{moment(conflictedData.endDate).format('MM-DD-YYYY')}</td>
                                                <td>{conflictedData.locker}</td>
                                                <td>{moment(conflictedData.openTime, 'HH:mm').format('H:mm')}</td>
                                                <td>{moment(conflictedData.closeTime, 'HH:mm').format('H:mm')}</td>
                                            </tr>
                                        ))}
                                    </table>
                                ) : (
                                    <p style={{ padding: 16 }}>No conflicts with other availability. Press Add Availability to continue.</p>
                                )}
                            </div> */}
                            {(conflictedAvailabilityData && conflictedAvailabilityData?.length === 0) ||
                                lockerType?.toLowerCase() === 'bms' ? (
                                <div className={styles.btnWrapper}>
                                    <button onClick={handleAddAvailability}>Add Availability</button>
                                </div>
                            ) : (
                                <div className={styles.btnWrapper} onClick={handleChangeAvailability}>
                                    <button>Choose new Availability</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AvailabilityConflict;
